const isMobileDevice = () => {
  if (typeof window === "undefined" || typeof navigator === "undefined") return false;

  const userAgent = (navigator.userAgent || navigator.vendor || window.opera || "").toLowerCase();
  const platform = (navigator.platform || "").toLowerCase();
  const uaData = navigator.userAgentData;
  const isTouch = navigator.maxTouchPoints > 0;

  // 1. DEVTOOLS BLOCKER (The Logic You Need)
  // DevTools emulates "mobile" but usually keeps the desktop platform string.
  // If we see Win32/MacIntel but it's NOT a confirmed iPad, it's likely DevTools.
  const isIpadOs = platform === "macintel" && navigator.maxTouchPoints > 1;
  const isDesktopHardware = platform.includes("win") || (platform.includes("mac") && !isIpadOs);

  if (isDesktopHardware) {
    return false; // Force false if it's a PC/Mac, regardless of mobile emulation
  }

  // 2. Check Modern API (navigator.userAgentData)
  if (uaData?.mobile === true) return true;
  if (uaData?.platform?.toLowerCase().includes("android")) return true;

  // 3. Android/iOS String Checks
  if (platform.includes("android") || userAgent.includes("android")) return true;
  if (/iphone|ipad|ipod/.test(platform) || /iphone|ipad|ipod/.test(userAgent)) return true;

  // 4. Final Touch + Regex fallback
  const isMobileRegex = /android|iphone|ipad|ipod|windows phone|blackberry|opera mini|mobile/i.test(userAgent);
  return isTouch && isMobileRegex;
};

export default isMobileDevice;